import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
const PdfToData = () => {
	const [leftWidth, setLeftWidth] = useState(50);
	const [startX, setStartX] = useState(0);
	const [images, setImages] = useState(["/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0001-1.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0001-2.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0002-3.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0002-4.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0003-5.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0003-6.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0004-7.png", "/static/pages/fd541482-3bd8-45f3-a93e-20c2067050e1/image0005-8.png"]);
	const [scale, setScale] = useState(1);
	const [box, setBox] = useState([]);
	const [markdown, setMarkdown] = useState([
		`
| Item | Price | Quantity | Subtotal |
|---|---|---|---|
| N/O LF WHEAT BREAD | $2.99 | 1 | $2.99 |
| PBX THCK L/S BACON | $4.99 | 1 | $4.99 |
| PUBLIX BROWN GRAVY | $1.99 | 1 | $1.99 |
| TOP SIRLOIN STEAK | $15.99 | 1 | $15.99 |
| VITA PRTY SNK WINE | $10.99 | 1 | $10.99 |
| ORGANIC CARROTS | $0.99 | 1 | $0.99 |
| BRC FLRT EAT SMART | $1.29 | 1 | $1.29 |`,
	]);
	// setTimeout(() => {
	// 		document.getElementById("mainPdfEditor").scrollIntoView({ behavior: "smooth" });
	// }, 1000);
	window.onload = () => {
		const resizer = document.getElementById("dragMe");
		const leftSide = document.getElementById("mainViewer");
		const rightSide = document.getElementById("tableViewer");
		const mouseDownHandler = function (e) {
			setStartX(e.clientX);
			setLeftWidth(leftWidth);
			document.addEventListener("mousemove", mouseMoveHandler);
			document.addEventListener("mouseup", mouseUpHandler);
		};

		const mouseMoveHandler = function (e) {
			const dx = e.clientX - startX;
			const newLeftWidth = ((leftWidth + dx) * 100) / resizer.parentNode.getBoundingClientRect().width;
			if (newLeftWidth > 70) {
				setLeftWidth(70);
			} else if (newLeftWidth < 45) {
				setLeftWidth(45);
			} else {
				setLeftWidth(newLeftWidth);
			}

			resizer.style.cursor = "col-resize";
			document.body.style.cursor = "col-resize";

			leftSide.style.userSelect = "none";
			leftSide.style.pointerEvents = "none";

			rightSide.style.userSelect = "none";
			rightSide.style.pointerEvents = "none";
		};

		const mouseUpHandler = function () {
			resizer.style.removeProperty("cursor");
			document.body.style.removeProperty("cursor");

			leftSide.style.removeProperty("user-select");
			leftSide.style.removeProperty("pointer-events");

			rightSide.style.removeProperty("user-select");
			rightSide.style.removeProperty("pointer-events");
			document.removeEventListener("mousemove", mouseMoveHandler);
			document.removeEventListener("mouseup", mouseUpHandler);
		};
		resizer.addEventListener("mousedown", mouseDownHandler);
	};
	window.addEventListener("scroll", () => {
		try {
			if (window.scrollY > 70) {
				document.getElementById("navbar").classList.add("-translate-y-full");
			} else {
				document.getElementById("navbar").classList.remove("-translate-y-full");
			}
		} catch (e) {}
	});

	return (
		<div
			id="mainPdfEditor"
			onMouseEnter={() => {
				document.getElementById("mainPdfEditor").scrollIntoView({ behavior: "smooth" });
				document.getElementById("navbar").classList.add("-translate-y-full");
			}}
			className="h-screen flex flex-row flex-nowrap scroll-smooth bg-primary-50"
		>
			<div className="h-full w-[15%] bg-white shadow-xl">
				<div className="relative h-max border-[3px] border-black border-dashed rounded-[23px] m-3 flex flex-col items-center justify-center overflow-hidden">
					<input
						onChange={() => {
							let files = document.getElementById("inputFile").files;
							for (let i = 0; i < files.length; i++) {
								let file = files[i];
								let reader = new FileReader();
								reader.onload = function (e) {
									let fileViewer = document.createElement("div");
									fileViewer.classList.add("m-2", "px-2", "flex", "gap-2", "h-10", "rounded-lg", "bg-primary-100", "items-center", "cursor-pointer");
									fileViewer.innerHTML = `
										<svg width="20px" height="20px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="48" height="48" fill="white" fill-opacity="0.01"/>
											<path d="M8 40C8 36 8 10 8 10C8 6.68629 10.8654 4 14.4 4H40V36C40 36 19.9815 36 14.4 36C9.36225 36 8 36.6842 8 40Z" fill="#00b1de" stroke="#000000" stroke-width="4" stroke-linejoin="round"/>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M12 44H40V36H12C9.79086 36 8 37.7909 8 40C8 42.2091 9.79086 44 12 44Z" stroke="#000000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<p class="text-primary-700 font-bold truncate">${file.name}</p>
									`;
									fileViewer.addEventListener("click", () => {
										var formdata = new FormData();
										formdata.append("pdf", file, file.name);
										let boxeselem = document.getElementsByClassName("box");
										for (let index = 0; index < boxeselem.length; index++) {
											const boxelem = boxeselem[index];
											boxelem.style.opacity = 0;
										}
										var requestOptions = {
											method: "POST",
											body: formdata,
											redirect: "follow",
										};
										document.getElementById("loaderLeft").classList.remove("hidden");
										fetch(process.env.REACT_APP_API_URL + "/api/pdfToImage/", requestOptions)
											.then((response) => response.json())
											.then((result) => {
												setImages(result["images"]);
												document.getElementById("loaderLeft").classList.add("hidden");
												document.getElementById("loaderRight").classList.remove("hidden");

												var myHeaders = new Headers();
												myHeaders.append("Content-Type", "application/json");

												var raw = JSON.stringify({
													images: result["images"],
												});

												var requestOptions = {
													method: "POST",
													headers: myHeaders,
													body: raw,
													redirect: "follow",
												};

												fetch(process.env.REACT_APP_API_URL + "/api/imageToText/", requestOptions)
													.then((response) => response.json())
													.then((result) => {
														setMarkdown(result["markdown"]);
														setBox(result["box"]);
														let boxeselem = document.getElementsByClassName("box");
														for (let index = 0; index < boxeselem.length; index++) {
															const boxelem = boxeselem[index];
															boxelem.style.opacity = 1;
														}
														document.getElementById("loaderRight").classList.add("hidden");
													})
													.catch((error) => console.log("error", error));
											})
											.catch((error) => console.log("error", error));
									});
									document.getElementById("fileList").appendChild(fileViewer);
								};
								reader.readAsText(file);
							}
						}}
						id="inputFile"
						type="file"
						className="absolute opacity-0 top-0 left-0 w-full h-full"
					/>
					<img src="/static/images/upload.svg" alt="" className="h-8 w-8 mt-5 mb-2" />
					<p className="text-black text-[20px] text-center font-normal leading-6">Drag Files to Drop</p>
					<p className="text-black text-center">or</p>
					<p className="bg-[#E7E4E4] rounded-full px-2 text-[15px]">Browse Files</p>
					<p className="text-[11px] mt-2 mb-5">
						Max Files <b>10</b> with Sizes below <b>50 MB</b>
					</p>
				</div>
				<hr className="border border-primary-200" />
				<div id="fileList"></div>
			</div>
			<div id="mainViewer" className="relative h-full overflow-scroll noScroll" style={{ width: leftWidth + "%" }}>
				<div id="imageContainer" className="relative p-5 overflow-y-scroll noScroll h-auto">
					{images.map((image, index) => {
						let tempBox = [];
						let height = "";
						let width = "";
						try {
							tempBox = box[index][0]["words"];
							height = box[index][0]["height"];
							width = box[index][0]["width"];
						} catch {}
						return (
							<div key={index} className="relative">
								<img
									onClick={() => {
										document.getElementById("data-" + index).scrollIntoView({ behavior: "smooth" });
									}}
									id={"image-" + index}
									className="object-contain h-auto w-full rounded-lg border-2 shadow-lg mt-2 border-black/10"
									src={process.env.REACT_APP_API_URL + image}
								/>
								<div className="box">
									{tempBox.length > 0 ? (
										tempBox.map((block, index2) => {
											const word = block;
											let point1 = [word["boundingBox"]["vertices"][0]["x"], word["boundingBox"]["vertices"][0]["y"]];
											let point3 = [word["boundingBox"]["vertices"][2]["x"], word["boundingBox"]["vertices"][2]["y"]];
											let heightTemp = ((point3[1] - point1[1]) * 100) / height;
											let widthTemp = ((point3[0] - point1[0]) * 100) / width;
											return <div key={index2} className="absolute outline outline-1 outline-primary-500 outline-offset-1 text-[6px] text-transparent overflow-hidden bg-transparent transition-all duration-300 cursor-pointer focus:scale-95" style={{ top: (point1[1] * 100) / height + "%", left: (point1[0] * 100) / width + "%", height: heightTemp + "%", width: widthTemp + "%" }}></div>;
										})
									) : (
										<></>
									)}
								</div>
							</div>
						);
					})}
				</div>
				<div className="sticky bottom-3 left-3 bg-primary-500 border-2 border-primary-800 w-10 h-fit rounded-lg flex flex-col items-center justify-between overflow-hidden">
					<div
						onClick={() => {
							let imageContainer = document.getElementById("imageContainer");
							//scale imageContainer
							imageContainer.style.transform = "scale(" + (scale + 0.1) + ")";
							setScale(scale + 0.1);
							imageContainer.style.transformOrigin = "top left";
						}}
						className="hover:scale-110 transition-all duration-300"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="white" viewBox="0 0 16 16">
							<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
						</svg>
					</div>
					<hr className="border border-primary-800 w-full"></hr>
					<div
						onClick={() => {
							let imageContainer = document.getElementById("imageContainer");
							//scale imageContainer
							imageContainer.style.transform = "scale(" + (scale - 0.1) + ")";
							setScale(scale - 0.1);
							imageContainer.style.transformOrigin = "top left";
						}}
						className="hover:scale-110 transition-all duration-300"
					>
						<svg width={30} height={30} viewBox="0 0 24 24" fill="white">
							<line
								id="primary"
								x1={17}
								y1={12}
								x2={7}
								y2={12}
								style={{
									fill: "none",
									stroke: "white",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 2,
								}}
							/>
						</svg>
					</div>
				</div>
				<div id="loaderLeft" className="hidden absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black/50">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							margin: "auto",
							background: "#ffffff00",
							display: "block",
						}}
						width="197px"
						height="197px"
						viewBox="0 0 100 100"
						preserveAspectRatio="xMidYMid"
					>
						<circle cx={50} cy={50} fill="none" stroke="#00b1de" strokeWidth={10} r={36} strokeDasharray="169.64600329384882 58.548667764616276">
							<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
						</circle>
					</svg>
				</div>
			</div>
			<div class="bg-primary-100 hover:bg-primary-500 h-full w-1 cursor-col-resize transition-all duration-300" id="dragMe"></div>
			<div id="tableViewer" className="relative h-full bg-white shadow-xl overflow-y-scroll noScroll" style={{ resize: "horizontal", width: 85 - leftWidth + "%" }}>
				<div id="loaderRight" className="hidden sticky top-0 left-0 w-full h-full flex items-center justify-center bg-black/50">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							margin: "auto",
							background: "#ffffff00",
							display: "block",
						}}
						className="sticky top-0"
						width="197px"
						height="197px"
						viewBox="0 0 100 100"
						preserveAspectRatio="xMidYMid"
					>
						<circle cx={50} cy={50} fill="none" stroke="#00b1de" strokeWidth={10} r={36} strokeDasharray="169.64600329384882 58.548667764616276">
							<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
						</circle>
					</svg>
				</div>
				{markdown.map((md, index) => (
					<div key={index} className="mb-8 border-b-2 border-primary-300 p-5 h-max overflow-x-scroll noScroll">
						<p
							onClick={() => {
								document.getElementById("image-" + index).scrollIntoView({ behavior: "smooth" });
							}}
							id={"data-" + index}
							className="bg-primary-500 text-white text-lg font-bold px-3 py-1 mb-2 rounded-md w-fit hover:scale-105 transition-all duration-300 cursor-pointer"
						>
							Page {index + 1} :
						</p>
						<ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
					</div>
				))}
			</div>
		</div>
	);
};

export default PdfToData;
